import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiHomeAddressData, type EnrollmentMultiHomeAddressSubmitOutput } from '../../../../models'

export const getEnrollmentMultiHomeAddressDataMock: EnrollmentMultiHomeAddressData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/home-address',
  enrollmentData: {
    applicationId: '123',
  },
}

export const submitEnrollmentMultiHomeAddressDataMock: EnrollmentMultiHomeAddressSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/verify-identity',
  enrollmentData: {
    applicationId: '123',
  },
}

export const mockGetEnrollmentMultiHomeAddressData = graphql.mutation('getEnrollmentMultiHomeAddressData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiHomeAddressDataMock } })
})

export const mockSubmitEnrollmentMultiHomeAddressData = graphql.mutation('submitEnrollmentMultiHomeAddressData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiHomeAddressDataMock } })
})

export const mockEnrollmentMultiHomeAddress = [
  mockGetEnrollmentMultiHomeAddressData,
  mockSubmitEnrollmentMultiHomeAddressData,
]
